import { Injectable, EventEmitter} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {

  // private getPlay = new BehaviorSubject<any>(undefined);
  // getPlay: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public getPlay = new EventEmitter<any>();
  public isModalOpen = new EventEmitter<boolean>();

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();
  public isFacebookApp = false;

  receiptNotApprovedData: any;

  winDetails = {
    availableGames: 0,
    email: '',
    gameRK: '',
    hasWon: false,
    isFreeReward: false,
    isRewardDeliverable: true,
    reward: '',
    rewardPK: '',
    rewardSmallImage: '',
    rewardDescription: '',
    rewardImage: '',
    userRewardRK: '',
    videoName: '',
    mobileVideoName: ''
  };

  setWinDetails(data:any){
    this.winDetails = data
  }

  getWinDetails() {
    return this.winDetails
  }

  callGetPlay() {
    // this.getPlay.next (true);

    this.getPlay.emit(true)
  }
  setReceiptNotApprovedData(data:any) {
    this.receiptNotApprovedData = data;
  }

  getReceiptNotApprovedData() {
    return this.receiptNotApprovedData;
  }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  setModalOpen () {

  }

  hideModal() {
    this.isModalOpen.emit(false)
  }

  checkisFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor
    if((ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) || ua.indexOf('Instagram') > -1) {
      this.isFacebookApp = true;
    }
  }

  constructor() { }
}
